export const REQUEST_COLLABORATOR_OPTIONS = 'REQUEST_COLLABORATOR_OPTIONS';
export const REQUEST_COLLABORATOR_OPTIONS_FAIL = 'REQUEST_COLLABORATOR_OPTIONS_FAIL';
export const REQUEST_COLLABORATOR_OPTIONS_SUCCESS = 'REQUEST_COLLABORATOR_OPTIONS_SUCCESS';
